var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { forwardRef } from 'react';
import theme from '../theme';
import { CaptionLarge } from './special';
var BannerMessageStyle = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  width: 100%;\n  padding: 16px;\n  border: ", " solid\n    ", ";\n  border-radius: ", ";\n  position: absolute;\n  margin-top: 11px;\n  @media (min-width: ", "px) {\n    width: ", "px;\n  }\n  &:before {\n    content: '';\n    width: 15px;\n    height: 15px;\n    transform: rotate(45deg);\n    position: absolute;\n    left: ", ";\n    top: ", ";\n    border: ", " solid;\n    border-left-color: ", ";\n    border-top-color: ", ";\n    border-right-color: ", ";\n    border-bottom-color: ", ";\n    border-radius: 1px;\n    background: ", ";\n    display: ", ";\n\n    ", "\n  }\n"], ["\n  background: ", ";\n  width: 100%;\n  padding: 16px;\n  border: ", " solid\n    ", ";\n  border-radius: ", ";\n  position: absolute;\n  margin-top: 11px;\n  @media (min-width: ", "px) {\n    width: ", "px;\n  }\n  &:before {\n    content: '';\n    width: 15px;\n    height: 15px;\n    transform: rotate(45deg);\n    position: absolute;\n    left: ", ";\n    top: ", ";\n    border: ", " solid;\n    border-left-color: ", ";\n    border-top-color: ", ";\n    border-right-color: ", ";\n    border-bottom-color: ", ";\n    border-radius: 1px;\n    background: ", ";\n    display: ", ";\n\n    ", "\n  }\n"])), function (_a) {
    var type = _a.type, customBackground = _a.customBackground;
    return type === 'info' || type === 'pop' ? theme.tints.cyan : type === 'custom' ? customBackground : theme.tints.amber;
}, function (_a) {
    var type = _a.type;
    return (type === 'pop' ? '3px' : '1px');
}, function (_a) {
    var type = _a.type, customBorder = _a.customBorder;
    return type === 'info'
        ? theme.primaryColours.cyan.superDarkCyan
        : type === 'pop'
            ? theme.primaryColours.cyan.main
            : type === 'custom'
                ? customBorder
                : theme.primaryColours.amber.darkAmber;
}, function (props) { return (props.type === 'pop' ? '8px' : '4px'); }, theme.grid.resolution.tablet.width, function (_a) {
    var tabletWidth = _a.tabletWidth;
    return (tabletWidth ? tabletWidth : '388');
}, function (_a) {
    var arrowLocation = _a.arrowLocation;
    return (arrowLocation ? arrowLocation : '20px');
}, function (_a) {
    var type = _a.type;
    return (type === 'pop' ? '-11px' : '-9px');
}, function (_a) {
    var type = _a.type;
    return (type === 'pop' ? '3px' : '1px');
}, function (_a) {
    var type = _a.type, customBorder = _a.customBorder;
    return type === 'info'
        ? theme.primaryColours.cyan.superDarkCyan
        : type === 'pop'
            ? theme.primaryColours.cyan.main
            : type === 'custom'
                ? customBorder
                : theme.primaryColours.amber.darkAmber;
}, function (_a) {
    var type = _a.type, customBorder = _a.customBorder;
    return type === 'info'
        ? theme.primaryColours.cyan.superDarkCyan
        : type === 'pop'
            ? theme.primaryColours.cyan.main
            : type === 'custom'
                ? customBorder
                : theme.primaryColours.amber.darkAmber;
}, function (_a) {
    var type = _a.type, customBackground = _a.customBackground;
    return type === 'info' || type === 'pop' ? theme.tints.cyan : type === 'custom' ? customBackground : theme.tints.amber;
}, function (_a) {
    var type = _a.type, customBackground = _a.customBackground;
    return type === 'info' || type === 'pop' ? theme.tints.cyan : type === 'custom' ? customBackground : theme.tints.amber;
}, function (_a) {
    var type = _a.type, customBackground = _a.customBackground;
    return type === 'info' || type === 'pop' ? theme.tints.cyan : type === 'custom' ? customBackground : theme.tints.amber;
}, function (_a) {
    var hideArrow = _a.hideArrow;
    return (!hideArrow ? 'block' : 'none');
}, function (_a) {
    var type = _a.type, position = _a.position, customBorder = _a.customBorder, customBackground = _a.customBackground;
    return position === 'top' &&
        "\n        border-bottom-color: ".concat(type === 'info'
            ? theme.primaryColours.cyan.superDarkCyan
            : type === 'pop'
                ? theme.primaryColours.cyan.main
                : type === 'custom'
                    ? customBorder
                    : theme.primaryColours.amber.darkAmber, ";\n        border-right-color: ").concat(type === 'info'
            ? theme.primaryColours.cyan.superDarkCyan
            : type === 'pop'
                ? theme.primaryColours.cyan.main
                : type === 'custom'
                    ? customBorder
                    : theme.primaryColours.amber.darkAmber, ";\n        border-left-color: ").concat(type === 'info' || type === 'pop'
            ? theme.tints.cyan
            : type === 'custom'
                ? customBackground
                : theme.tints.amber, ";\n        border-top-color: ").concat(type === 'info' || type === 'pop'
            ? theme.tints.cyan
            : type === 'custom'
                ? customBackground
                : theme.tints.amber, ";  \n        top: auto;\n        bottom: ").concat(type === 'pop' ? '-11px' : '-9px', ";       \n      ");
});
export var InputMessage = forwardRef(function (_a, ref) {
    var type = _a.type, customBackground = _a.customBackground, customBorder = _a.customBorder, tabletWidth = _a.tabletWidth, arrowLocation = _a.arrowLocation, hideArrow = _a.hideArrow, position = _a.position, className = _a.className, errorId = _a.errorId, ariaLive = _a.ariaLive, message = _a.message, id = _a.id, style = _a.style;
    return (_jsx(BannerMessageStyle, __assign({ id: id, style: style, type: type, customBackground: customBackground, customBorder: customBorder, tabletWidth: tabletWidth, arrowLocation: arrowLocation, hideArrow: hideArrow, position: position, className: className }, { children: _jsx(CaptionLarge, __assign({ ref: ref, id: errorId || '', className: "".concat(className ? className : ' ', " LoNotSensitive"), style: { color: theme.primaryColours.aubergine.main }, "aria-live": ariaLive ? 'polite' : 'off' }, { children: message })) })));
});
var templateObject_1;
